module.exports = __webpack_public_path__ + "static/media/withoutReferreds.26815cd3.png";